var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectronics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 9.08791C51 4.80944 47.0058 1.97307 43.1796 2.66011C38.6829 3.46752 31.8286 4.1727 25.5 4.1727C19.1714 4.1727 12.3171 3.46752 7.82043 2.66011C3.99418 1.97307 0 4.80944 0 9.08791V21.8576V34.6272C0 38.9057 3.99418 41.742 7.82043 41.055C11.6756 40.3628 17.2638 39.7457 22.7679 39.5837V44.8033H16.8909C15.382 44.8033 14.1588 46.0265 14.1588 47.5354C14.1588 49.0444 15.382 50.2676 16.8909 50.2676H25.4667L25.5 50.2678L25.5333 50.2676H34.0953C35.6042 50.2676 36.8274 49.0444 36.8274 47.5354C36.8274 46.0265 35.6042 44.8033 34.0953 44.8033H28.2321V39.5837C33.7362 39.7457 39.3244 40.3628 43.1796 41.055C47.0058 41.742 51 38.9057 51 34.6272V21.8576V9.08791ZM25.5 11.4584C31.9349 11.4584 38.8319 10.7852 43.7143 9.96211V21.8576V33.753C38.8319 32.9299 31.9349 32.2567 25.5 32.2567C19.0651 32.2567 12.1681 32.9299 7.28571 33.753V21.8576V9.96211C12.1681 10.7852 19.0651 11.4584 25.5 11.4584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronics);
export default __webpack_public_path__ + "static/media/Electronics.538d4cf50f2ff42930e7dcc336b0e70a.svg";
export { ForwardRef as ReactComponent };